import initCardsSection from "../Components/Sections/AdvantageCardsSection";
import "Styles/Pages/TransactionManagerPage.scss";

initCardsSection();